const sleep = (m) => new Promise((r) => setTimeout(r, m));
export default sleep;
